import client from '../../base-api';

const serviceURL = '/dashboard/site-support';

const dashboardSiteSupportService = {

    getInfoData(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },
}

export default dashboardSiteSupportService;